import React, { FC, ReactElement, useEffect } from 'react';

import { IRouterProps } from '@core/models/generic.model';
import withRouter from 'Common/withRouter';
import AuthIcon from 'pages/AuthenticationInner/AuthIcon';
import logo from '../../../assets/images/finalLogo.svg'
interface IProps {
    children: ReactElement<{ router?: IRouterProps }>;
    router: IRouterProps;
}

const AuthLayout: FC<IProps> = ({ children, router }) => {
    //------------------------------------------------------------------------------------
    useEffect(() => {
        const bodyElement = document.body;
        bodyElement.classList.add(
            `flex`,
            `items-center`,
            `justify-center`,
            `min-h-screen`,
            `py-16`,
            `lg:py-10`,
            `bg-[#000]`,
            `dark:bg-zink-800`,
            `dark:text-zink-100`,
            `font-public`
        );
        return () => {
            bodyElement.classList.remove(
                `flex`,
                `items-center`,
                `justify-center`,
                `min-h-screen`,
                `py-16`,
                `lg:py-10`,
                `bg-[#000]`,
                `dark:bg-zink-800`,
                `dark:text-zink-100`,
                `font-public`
            );
        };
    }, []);
    //------------------------------------------------------------------------------------
    const newElement = React.cloneElement(children, {
        router: router,
    });
    //------------------------------------------------------------------------------------
    return (
        <>
            <div className="relative">
                <AuthIcon />
                <div
                    className="card relative mb-0 w-screen
                    border-none shadow-lg lg:mx-auto lg:w-[500px]"
                >
                    <div className="card-body !px-10 !py-12">
                        <img
                            src={logo}
                            alt=""
                            className="mx-auto h-48 w-48 object-cover"
                        />
                        {newElement}
                    </div>
                </div>
            </div>
        </>
    );
};

export default withRouter(AuthLayout);
